import { render, staticRenderFns } from "./FulfillmentSummary.vue?vue&type=template&id=2f10747a"
import script from "./FulfillmentSummary.vue?vue&type=script&lang=js"
export * from "./FulfillmentSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports